<div class=" d-flex justify-content-end align-content-center gap-2">
  <div>
    <app-account-filter [filter]="accountFilter" class="w-50 py-2"
      (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
  </div>

  <div>
    <app-driver-filter 
      [filter]="driverFilter"
      [accountFilterChanged$]="accountFilterChanged$"
      (filterChanged)="onDriverFilterChange($event)"></app-driver-filter>
  </div>

  <div class="date-height">
    <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
      (filterChanged)="onDateFilterChange($event)"></app-date-filter>
  </div>
</div>